
import React from "react";

const CustomScrollbar: React.FC = () => {
  return (
    <style>
      {`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
          background: #11141b;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #2A3749;
          border-radius: 10px;
        }
      `}
    </style>
  );
};

export default CustomScrollbar;
